import { render, staticRenderFns } from "./PazienteTerapiaView.vue?vue&type=template&id=4bfe1c25&scoped=true"
import script from "./PazienteTerapiaView.vue?vue&type=script&lang=js"
export * from "./PazienteTerapiaView.vue?vue&type=script&lang=js"
import style0 from "./PazienteTerapiaView.vue?vue&type=style&index=0&id=4bfe1c25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe1c25",
  null
  
)

export default component.exports